<template>
  <button
    class="flex w-full cursor-pointer items-center justify-center rounded-full border-none bg-white py-3 text-black hover:bg-nordy"
    @click="login"
  >
    <span class="pi pi-google mr-2 text-2xl"></span>
    {{ loginGoogle }}
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { googleTokenLogin } from 'vue3-google-login'

import { nordyApi } from '@/nordy/api'
import { useNordyUserStore } from '@/nordy/store/nordyUserStore'
import { trackNordyAuth } from '@/nordy/utils/gtm'
import { Gtag } from '@/nordy/utils/gtag'
import { getMixpanelAdditionalInfo } from '@/nordy/utils/mixpanelAdditionalInfo'
import { saveOAuthAttributionSnapshot } from '@/nordy/utils/mixpanelOAuthAttribution'

const nordyUserStore = useNordyUserStore()
const isKo = computed(() => nordyUserStore.nordyUser?.language === 'ko')
const loginGoogle = computed(() =>
  isKo.value ? 'Google로 로그인' : 'Sign in with Google'
)

const emit = defineEmits<{
  (e: 'loginSuccess'): void
}>()
const login = async () => {
  const entryPath = window.location.pathname
  Gtag.comfyui_login_click({ provider: 'google' })
  saveOAuthAttributionSnapshot(getMixpanelAdditionalInfo(), {
    $current_url: window.location.href
  })
  await googleTokenLogin().then(async (response) => {
    try {
      const code = response.access_token
      const user = await nordyApi.signupOrLoginByGoogle({ code })
      trackNordyAuth(user, 'google', entryPath)
      Gtag.comfyui_login_success({ provider: 'google' })
      emit('loginSuccess')
    } catch (error) {
      console.error(error)
    }
  })
}
</script>
